import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
// import "reflect-metadata";

/*
  Generated class for the Servis provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class Servis {


  constructor(public http: Http) {
   
  }

  makePostRequest(servisAdresi: string, postData: any) {
    return new Promise((resolve, reject) => {
      this.http.post(servisAdresi, postData).map(res => res.json())
        .subscribe(data => {
          resolve(data);
        }, (error) => {
          reject(error);
        });
    });
  };

  makePostRequestWithoutJsonResult(servisAdresi: string, postData: any) {
    return new Promise((resolve, reject) => {
      this.http.post(servisAdresi, postData)
        .subscribe(data => {
          resolve(data);
        }, (error) => {
          reject(error);
        });
    });
  };

  makeGetRequest(servisAdresi: string) {
    return new Promise((resolve, reject) => {
      this.http.get(servisAdresi).map(res => res.json())
        .subscribe(data => {
          resolve(data);
        }, (error) => {
          reject(error);
        });
    });
  }

  makeGetRequestWithoutJsonResult(servisAdresi: string) {
    return new Promise((resolve, reject) => {
      this.http.get(servisAdresi)
        .subscribe(data => {
          resolve(data);
        }, (error) => {
          reject(error);
        });
    });
  }

}



// WEBPACK FOOTER //
// ./src/providers/servis.ts